import {useGoogleMap} from "@react-google-maps/api";
import {useEffect, useRef} from "react";

export type MapLineProps = {
  path: google.maps.LatLngLiteral[];
  options?: Omit<google.maps.PolylineOptions, "map" | "path">;
};

/**
 * A polyline on the enclosing map that updates in place and always comes off when unmounted; the library's
 * function components can leave theirs drawn (see TrafficLayer).
 */
export const MapLine = ({path, options}: MapLineProps) => {
  const map = useGoogleMap();
  const line = useRef<google.maps.Polyline | undefined>(undefined);

  useEffect(() => {
    if (!map) return;
    const polyline = new google.maps.Polyline({map});
    line.current = polyline;
    return () => {
      polyline.setMap(null);
      line.current = undefined;
    };
  }, [map]);

  useEffect(() => {
    line.current?.setOptions({...options, path});
  }, [map, path, options]);

  return null;
};
